<template>
    <transition name="slide-fade" class="fadeView">
        <div  v-show="modelShow">
            <div class="imgView"
                 @click="close">
                    <img v-if="imgSrc" :src="imgSrc" alt="">
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        data(){
            return {
                modelShow: false,
                imgSrc: null
            }
        },
        props: {
          imgW: {
              type: Number
          }
        },
        computed: {
//          viewHeight(){
//             return document.body.clientHeight
//          },
//            viewWidth(){
//                return document.body.clientWidth
//            }
        },
        methods: {
            open(src){
               this.modelShow = true
                this.imgSrc = src
            },
            close() {
                this.modelShow = false
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .slide-fade-enter-active {
        transition: opacity .2s ease;
    }

    .slide-fade-leave-active {
        transition: opacity .2s ease;
    }

    .slide-fade-enter, .slide-fade-leave-active {
        opacity: 0;
    }
    .imgView{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10000;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        overflow: auto;
        img{
            display: block;
            margin: 60px auto;
        }
    }
</style>